import {getServiceEnvironment} from './getServiceEnvironment';

/**
 * Returns the base URL for the Link app based on the current environment.
 *
 * @returns The Link app base URL for the current environment, or null if environment is invalid
 */
export const getLinkAppBaseUrl = (): string | null => {
  const env = getServiceEnvironment();
  const {hostname} = window.location;

  switch (env) {
    case 'prod':
    case 'preprod':
      return 'https://app.link.com';
    case 'qa':
    case 'isolated_qa':
      return 'https://qa-app.link.com';
    case 'devbox':
      // Extract dev box username from hostname for dev environment
      const match = hostname.match(/^([^-]+(?:-[^-]+)+)--/);
      const devBoxUserName = match ? match[0] : null;

      return `https://${devBoxUserName}link_app_frontend-mydev.dev.stripe.me`;
    default:
      return null;
  }
};
